import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { OperatorPresenceAPI } from '../../constants/API';
import { commonHeaders } from '../../constants/HeadersAPI';

export type OperatorPresence =
  | 'FREE'
  | 'BUSY'
  | 'BREAK'
  | 'SERVING'
  | 'WAITING_PATIENT'
  | 'ABSENT';

export type OperatorPresenceDto = {
  presence: OperatorPresence;
  displayName: string;
  noShowTimeoutSeconds: number | null;
  autoDistributeEnabled: boolean;
  autoDistributeDelaySeconds?: number | null;
  presenceChangedAt?: string | null;
  /** Осталось секунд до автовызова (считается на сервере) */
  autoCallRemainingSeconds?: number | null;
  benefitTicketColor?: string | null;
  otoTicketColor?: string | null;
};

export const useOperatorPresence = (
  enabled: boolean,
  options?: { polling?: boolean }
) => {
  const queryClient = useQueryClient();
  const polling = options?.polling !== false;

  const query = useQuery(
    ['operatorPresence'],
    async () => {
      const { data } = await axios.get<OperatorPresenceDto>(
        OperatorPresenceAPI.get,
        commonHeaders()
      );
      return data;
    },
    {
      enabled,
      refetchInterval: polling ? 2000 : false,
    }
  );

  const mutation = useMutation(
    (presence: OperatorPresence) =>
      axios.put<OperatorPresenceDto>(OperatorPresenceAPI.update, { presence }, commonHeaders()),
    {
      onSuccess: (response) => {
        queryClient.setQueryData(['operatorPresence'], response.data);
      },
    }
  );

  return {
    presenceData: query.data,
    isLoadingPresence: query.isLoading,
    setPresence: mutation.mutate,
    isUpdatingPresence: mutation.isLoading,
  };
};
